import {
  ApprovalIndicator,
  ApprovalStatus,
  FileStatus,
  PermissionLevel,
} from '@models';

const INDICATOR_BY_STATUS: Partial<Record<FileStatus, ApprovalIndicator>> = {
  [FileStatus.PUBLISHED]: ApprovalIndicator.APPROVED,
  [FileStatus.TO_BE_APPROVED]: ApprovalIndicator.PENDING,
  [FileStatus.REJECTED]: ApprovalIndicator.REJECTED,
};

export const defineApproval = (file: {
  approval?: ApprovalStatus;
  status: number;
}): ApprovalIndicator =>
  file.approval
    ? (INDICATOR_BY_STATUS[file.status as FileStatus] ?? ApprovalIndicator.NONE)
    : ApprovalIndicator.NONE;

export const defineVersionApproval = (
  resource: { approver?: boolean; permission: number },
  version: {
    status: number;
    approvalRequestDate?: number;
    publicationDate?: number;
  }
): ApprovalIndicator =>
  (version.status !== 0 ||
    version.approvalRequestDate !== version.publicationDate) &&
  (resource.approver || resource.permission > PermissionLevel.CONTRIBUTE)
    ? (INDICATOR_BY_STATUS[version.status as FileStatus] ??
      ApprovalIndicator.NONE)
    : ApprovalIndicator.NONE;
